import { type___locale___translations___collection } from '../../types/types.locale';

//	E X P O R T   L O C A L E

export const locale___ComCopyrightComponent: type___locale___translations___collection = {
	'row1': {
		de_de: 'Dieses Menü wurde dank LinkToMenu erstellt',
		en_us: 'This menu was created thanks to LinkToMenu',
		es_es: 'Este menú fue creado gracias a LinkToMenu',
		fr_fr: 'Ce menu a été créé grâce à LinkToMenu',
		it_it: 'Questo Menù è stato creato grazie a LinkToMenu'
	},
	'row2': {
		de_de: '© Copyright 2016 - {{1}} by PRYSM',
		en_us: '© Copyright 2016 - {{1}} by PRYSM',
		es_es: '© Copyright 2016 - {{1}} by PRYSM',
		fr_fr: '© Copyright 2016 - {{1}} by PRYSM',
		it_it: '© Copyright 2016 - {{1}} by PRYSM',
	},
	'row3': {
		de_de: "„LinkToMenu“ ist eine eingetragene Marke, die ausschließlich PRYSM LAB gehört. Jede Vervielfältigung, auch teilweise, ist untersagt.",
		en_us: "\"LinkToMenu\" is a registered trademark exclusively owned by PRYSM LAB. Any reproduction, even partial, is prohibited.",
		es_es: "\"LinkToMenu\" es una marca registrada propiedad exclusiva de PRYSM LAB. Cualquier reproducción, incluso parcial, está prohibida.",
		fr_fr: "\"LinkToMenu\" est une marque déposée, propriété exclusive de PRYSM LAB. Toute reproduction, même partielle, est interdite.",
		it_it: "\"LinkToMenu\" è un marchio registrato di proprietà esclusiva di PRYSM LAB, ogni sua riproduzione anche parziale è vietata."
	},
};